module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("個人資料")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("帳號")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-1-5",
      "label": "帳號",
      "value": "",
      "single-line": ""
    },
    model: {
      value: (_vm.profile.account),
      callback: function($$v) {
        _vm.$set(_vm.profile, "account", $$v)
      },
      expression: "profile.account"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("姓名")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input-4-5",
      "label": "姓名",
      "value": "",
      "single-line": ""
    },
    model: {
      value: (_vm.profile.name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "name", $$v)
      },
      expression: "profile.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm4": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-subheader', [_vm._v("聯絡電話")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "input-5-5",
      "label": "聯絡電話",
      "value": "",
      "single-line": ""
    },
    model: {
      value: (_vm.profile.phone),
      callback: function($$v) {
        _vm.$set(_vm.profile, "phone", $$v)
      },
      expression: "profile.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$store.getters.user.provider === 'LiveABC') ? _c('v-card-row', {
    staticClass: "mt-4",
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.link('https://www.liveabc.com/site/online_store/member/log2.asp')
      }
    }
  }, [_vm._v("編輯")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "white--text primary"
  }, [_c('v-card-row', [_c('v-card-title', [_vm._v("\n              使用時數\n            ")])], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', [_c('h5', {
    staticClass: "white--text hidden-sm-and-down",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(this.profile.spendTime ? this.profile.spendTime : ' '))]), _vm._v(" "), _c('h3', {
    staticClass: "white--text hidden-md-and-up",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(this.profile.spendTime ? this.profile.spendTime : ' '))])])], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [(false) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": "",
      "router": "",
      "href": "/user/period"
    }
  }, [_c('v-icon', [_vm._v("search")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "white--text primary"
  }, [_c('v-card-row', [_c('v-card-title', [_vm._v("\n              星星數量\n            ")])], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', [_c('h5', {
    staticClass: "white--text hidden-sm-and-down",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(this.profile.starCount) + " 個")]), _vm._v(" "), _c('h3', {
    staticClass: "white--text hidden-md-and-up",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(this.profile.starCount) + " 個")])])], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [(false) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": "",
      "router": "",
      "href": "/user/coin"
    }
  }, [_c('v-icon', [_vm._v("search")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "white--text primary"
  }, [_c('v-card-row', [_c('v-card-title', [_vm._v("\n               \n            ")])], 1), _vm._v(" "), _c('v-card-row', [_c('v-card-text', [_c('h5', {
    staticClass: "white--text hidden-sm-and-down",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('h3', {
    staticClass: "white--text hidden-md-and-up",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" ")])])], 1), _vm._v(" "), _c('v-card-row', {
    attrs: {
      "actions": ""
    }
  }, [(false) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90566360"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyProfile.vue
// module id = 784
// module chunks = 1